/**
 * postMessage contract between Angular portal (parent) and React planner (iframe).
 */

export const PORTAL_MESSAGE_SOURCE = 'nemt-portal';
export const PLANNER_MESSAGE_SOURCE = 'nemt-planner';

export const PORTAL_MESSAGE_TYPES = Object.freeze({
  NAVIGATE: 'NAVIGATE',
  ROUTE_CHANGED: 'ROUTE_CHANGED',
});

/** React Router paths Angular may request. */
export const PORTAL_EMBED_ROUTES = Object.freeze([
  '/',
  '/bucket',
  '/maps',
  '/portal-plan',
  '/charts',
]);

export function isAllowedEmbedPath(path) {
  if (typeof path !== 'string') return false;
  const normalized = path.trim();
  if (!normalized) return false;
  // Allow path-only; reject absolute URLs / open redirects.
  if (!normalized.startsWith('/') || normalized.startsWith('//')) return false;
  return PORTAL_EMBED_ROUTES.includes(normalized);
}

/**
 * @returns {{ path: string } | null}
 */
export function parseNavigateMessage(data) {
  if (!data || typeof data !== 'object') return null;
  if (data.source !== PORTAL_MESSAGE_SOURCE) return null;
  if (data.type !== PORTAL_MESSAGE_TYPES.NAVIGATE) return null;
  if (!isAllowedEmbedPath(data.path)) return null;
  return { path: data.path.trim() };
}

export function buildRouteChangedMessage(path) {
  return {
    source: PLANNER_MESSAGE_SOURCE,
    type: PORTAL_MESSAGE_TYPES.ROUTE_CHANGED,
    path,
  };
}
